// @flow
import type { ActionsState } from '~/core/state/actions/types';

import { connect } from 'react-redux';
import { actionFormComponentId, createComponentId } from '~/core/utils/schedule';
import { getConfig } from '~/core/state/config/selectors';
import { getScheduleData } from '~/core/state/ui/schedule/selectors';
import { setupActionFormSchedule } from '~/core/state/ui/schedule/actions';
import ActionSchedule from './component';

type Props = { actionId: ?string };
const mapStateToProps = (state: { actions: ActionsState }, { actionId }: Props) => {
    // $FlowFixMe, can't understand why the complaining, I guess because schedule section is not properly typed so one for later
    const schedule = getScheduleData(state, { componentId: createComponentId('action', actionId) });
    const defaultSchedule = getConfig(state, 'actions:defaultSchedule');
    return {
        defaultSchedule,
        schedule,
        scheduleComponentId: actionFormComponentId
    };
};

const mapDispatchToProps = {
    setupActionFormSchedule
};

const mergeProps = ({ defaultSchedule, schedule, ...restStateProps }, dispatchProps, ownProps) => {
    const { setupActionFormSchedule } = dispatchProps;

    return {
        ...ownProps,
        ...restStateProps,
        setNewSchedule: () => setupActionFormSchedule({ defaultSchedule, schedule })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ActionSchedule);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/schedule/index.js